module.exports = __webpack_public_path__ + "static/media/phone.2bde434a.svg";